import AccountCenterSearch from "utils/account_center_search"

const PersonImportModal = {
  initialize(redirect_to) {
    this.redirectTo = redirect_to
    return AccountCenterSearch.init(this)
  },

  selectPerson(accountCenterId) {
    const input = $(
      `<input type='hidden' name='new_person_account_center_id' value='${accountCenterId}' />`
    )
    $("#import-person-form-js").append(input)
    return $("#import-person-form-js").submit()
  }
}

export default PersonImportModal
